/**
 * Flights status lookups for current and future (2 weeks out?) flights
 * @author      Jeff Adams <jeff@tinyfly.com>
 * @copyright   Traxo, Inc. 2020
 */

import moment from 'moment';
import { FlightStatusApi } from '@/services/api-travel-flight-status.js';

/**
 * Local state data
 * -----------------------------------------------------
 */
export const state = {
  all: [],
};

/**
 * Computed properties of the local state
 * -----------------------------------------------------
 */
export const getters = {
  statusById: (state) => (id) => {
    return state.all.find((status) => status.Segment_id === id);
  },

  statusIndexById: (state) => (id) => {
    return state.all.findIndex((status) => status.Segment_id === id);
  },
};

/**
 * Synchronous changes to the local state
 * -----------------------------------------------------
 */
export const mutations = {
  UPDATE_STATUSES(state, statuses = []) {
    state.all = statuses;
  },

  UPDATE_CURRENT_STATUS(state, { status, index = -1 }) {
    if (index !== -1) {
      state.all[index] = status;
    } else if (status) {
      state.all.push(status);
    }
  },
};

/**
 * Async CRUD actions against the api
 * -----------------------------------------------------
 */
export const actions = {
  index({ commit }, { startDate = moment().format('YYYY-MM-DD'), endDate }) {
    FlightStatusApi.index({ startDate, endDate })
      .then((statuses) => {
        commit('UPDATE_STATUSES', statuses);
      })
      .catch(() => {
        commit('UPDATE_STATUSES', []);
      });
  },

  show({ commit, getters }, { id }) {
    FlightStatusApi.show(id).then((status) => {
      const index = getters.statusIndexById(id);
      commit('UPDATE_CURRENT_STATUS', { status, index });
    });
  },
};
